import { Injectable } from '@angular/core';
import { Client, User } from '@fb-tool-front/shared/interfaces/auth.type';
import { Product, ProductCatalog } from '@fb-tool-front/shared/interfaces/catalogs.type';
import { BehaviorSubject, merge } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class OverlaysStepperService {
  public currentStep$$ = new BehaviorSubject<number>(0);
  public currentStep$ = this.currentStep$$.asObservable();

  public availableStep$$ = new BehaviorSubject<number>(0);
  public availableStep$ = this.availableStep$$.asObservable();

  public productExample: Product;
  public catalogExample: ProductCatalog;

  constructor(private authService: AuthService) {
    merge(
      this.authService.client$.pipe(
        distinctUntilChanged((x: Client, y: Client) => x?.id === y?.id)
      ),
      this.authService.user$.pipe(
        distinctUntilChanged((x: User, y: User) => x?.username === y?.username)
      )
    ).subscribe(() => {
      this.currentStep$$.next(0);
      this.availableStep$$.next(0);
      this.productExample = undefined;
      this.catalogExample = undefined;
    });
  }
}
